import React, { useState } from "react";

import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
} from "@material-ui/core";

import {
  Add,
  Remove,
  Close,
  FavoriteBorder,
  Share,
  ShoppingBasketOutlined,
} from "@material-ui/icons";

import { Product } from "./ProductCard";

interface ProductDetailsModalProps {
  product: Product | null;
  open: boolean;
  onClose: () => void;
  onAddToCart?: (
    product: Product,
    quantity: number
  ) => void;
}

const ProductDetailsModal: React.FC<
  ProductDetailsModalProps
> = ({
  product,
  open,
  onClose,
  onAddToCart,
}) => {
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return null;
  }

  const increaseQuantity = () => {
    setQuantity((current) => current + 1);
  };

  const decreaseQuantity = () => {
    setQuantity((current) =>
      Math.max(1, current - 1)
    );
  };

  const handleAddToCart = () => {
    onAddToCart?.(product, quantity);
  };

  const category =
    product.categories?.join(", ") ||
    "Organic Food";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="product-details-modal"
      className="product-details-modal"
    >
      <Box className="product-details-popup">

        {/* =========================
            CLOSE BUTTON
        ========================= */}

        <IconButton
          className="product-details-close"
          onClick={onClose}
        >
          <Close />
        </IconButton>

        {/* =========================
            LEFT - IMAGE
        ========================= */}

        <div className="product-popup-image-section">

          <div className="product-popup-image-box">

            <img
              src={product.image}
              alt={product.name}
              className="product-popup-image"
            />

          </div>

        </div>

        {/* =========================
            RIGHT - DETAILS
        ========================= */}

        <div className="product-popup-content">

          {/* Rating */}

          <div className="product-popup-rating">

            <span className="rating-stars">
              ★★★★★
            </span>

            <Typography className="review-count">
              (5 customer reviews)
            </Typography>

          </div>

          {/* Product Name */}

          <Typography
            id="product-details-modal"
            className="product-popup-title"
          >
            {product.name}
          </Typography>

          {/* Price */}

          <div className="product-popup-price">

            <Typography className="popup-current-price">
              ₹{product.price.toFixed(2)}
            </Typography>

            {product.oldPrice !== undefined && (
              <Typography className="popup-old-price">
                ₹{product.oldPrice.toFixed(2)}
              </Typography>
            )}

          </div>

          {/* Description */}

          <Typography className="product-popup-description">
            {product.description ||
              "Fresh and high quality organic product. Carefully selected to provide you with the best natural taste and quality."}
          </Typography>

          {/* Quantity */}

          <div className="product-popup-quantity">

            <IconButton
              size="small"
              onClick={decreaseQuantity}
            >
              <Remove />
            </IconButton>

            <Typography>
              {quantity}
            </Typography>

            <IconButton
              size="small"
              onClick={increaseQuantity}
            >
              <Add />
            </IconButton>

          </div>

          {/* More Information */}

          <div className="product-popup-more-info">
            MORE INFORMATION
          </div>

          {/* Bottom Actions */}

          <div className="product-popup-bottom">

            <Button
              startIcon={<ShoppingBasketOutlined />}
              className="popup-add-cart"
              onClick={handleAddToCart}
            >
              ADD TO CART
            </Button>

            <div className="popup-actions">

              <IconButton>
                <Share />
              </IconButton>

              <IconButton>
                <FavoriteBorder />
              </IconButton>

            </div>

          </div>

          {/* Meta */}

          <div className="product-popup-meta">

            <Typography>
              <strong>Category:</strong>{" "}
              {category}
            </Typography>

            <Typography>
              <strong>Availability:</strong>{" "}
              {product.stock &&
              product.stock > 0
                ? "In Stock"
                : "Out of Stock"}
            </Typography>

          </div>

        </div>
      </Box>
    </Modal>
  );
};

export default ProductDetailsModal;